import { MoveEventTypeMapBM } from '../types/BusinessModel/MoveEventTypeMapBM';

export class MoveEventsToCargoOperationFactory {
    constructor() {}

    public createMoveEventsToCargoOperationBM(
        imoNumber: number,
        portCallId: number,
        cargoOperationId: number,
        fromBerthCallId: number,
        toBerthCallId: number,
        toBerthId: number,
        user: string,
        moveEventTypeMapList: MoveEventTypeMapBM[]
    ): any {
        return {
            imoNumber: imoNumber,
            portCallId: portCallId,
            cargoOperationId: cargoOperationId,
            fromBerthCallId: fromBerthCallId,
            toBerthCallId: toBerthCallId,
            toBerthId: toBerthId,
            user: user,
            moveEventTypeMapList: moveEventTypeMapList,
        };
    }
}
